<template>
    <div>
        <navbar></navbar>
        <div class="__contactbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-7 col-sm-7">
                        <p class="__welf1">Hi, nice to meet you</p>
                        <p class="__welf2">
                        Want to work with us on a project? Or you're simply just curious
                        about our secret lab or what we might be cooking up next? Well,
                        you're in the right place!
                        </p>
                    </div>
                    <div class="col-lg-6 col-md-5 col-sm-5"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="__form-wrap ">
                <div class="row ">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <p><a href="tel:(+234) 913 402 9026"><i class="fas fa-phone"></i> &nbsp;&nbsp; (+234) 913 402 9026</a></p>
                        <p>
                        <a href="mailto:info@findworka.com"><i class="fas fa-envelope"></i> &nbsp;&nbsp; info@findworka.com</a>
                        </p>
                        <p>
                        <i class="fas fa-map-marker-alt"></i> &nbsp;&nbsp; 232, Muritala Muhammad way, Adekunle, Yaba
                        </p>
                        <p>
                        Follow us: &nbsp;&nbsp;
                        <a href="https://www.facebook.com/findworka" target="_blank"><i class="fab fa-facebook-square"></i></a> &nbsp;&nbsp;
                        <a href="https://twitter.com/findworka" target="_blank"><i class="fab fa-twitter"></i></a> &nbsp;&nbsp;
                        <a href="https://www.instagram.com/findworka/" target="_blank"><i class="fab fa-instagram"></i></a> &nbsp;&nbsp;
                        <a href="https://www.linkedin.com/company/findworka/" target="_blank"><i class="fab fa-linkedin"></i></a>
                        </p>
                    </div>
                    <div class="col-lg-8 __adjust-form col-md-8 col-sm-8">
                        <p class="__hirep">
                        Want to send us something?
                        </p>

                        <form @submit.prevent="processForm()" method="POST" enctype="multipart/form-data">
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label for="fullName">Full name</label>

                                    <input
                                    type="text"
                                    class="form-control __form-control"
                                    id="fullName"
                                    name="fullName"
                                    data-field="general"
                                    v-model="formField.fullName"
                                    placeholder="John Jane Doe"
                                    required="required"
                                    />
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label for="email">Email</label>

                                    <input
                                        type="email"
                                        class="form-control __form-control"
                                        id="email"
                                        name="email"
                                        data-field="email"
										v-model="formField.email"
                                        placeholder="address@yourdomain.com"
										required="required"
                                        />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label for="phoneNumber">Phone number</label>
                                    <input
                                        type="tel"
                                        class="form-control __form-control"
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        data-field="phoneNumber"
										v-model="formField.phoneNumber"
                                        placeholder="+234 810 544 8756"
                                        />
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label for="company">Company</label>

                                    <input
                                    type="text"
                                    class="form-control __form-control"
                                    id="company"
                                    name="company"
                                    data-field="general"
                                    v-model="formField.company"
                                    placeholder="Enter company name"
                                    required
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="form-group">
                                    <label for="message">What do you want to tell us</label>

                                    <textarea
                                    class="form-control"
                                    id="message"
                                    name="message"
                                    rows="5"
                                    data-field="general"
                                    v-model="formField.message"
                                    placeholder="Type here"
                                    required
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-5 col-md-5 col-sm-5">
                            <button type="submit" class="btn btn-block __adjustlink "
                                >Submit form</button>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navbar from "../components/navbar";
import axios from 'axios'
export default {
    components: { navbar },
    data () {
        return{
        formField: {
            fullName: null,
            email: null,
            phoneNumber: null,
            message: null,
            company: null,
        },
        redirect: true   
        }
    },

    methods: {
        processForm: function() {
                this.$validator.validateAll().then(() => {
                    if (! this.errors.any()) {
                        // Make the api call for form submission
                        this.makeFormRequest()
                    } else {
                        // Show form validation error toast
                        this.$toasted.global.form_validation_error()
                    }
                });
            },
            makeFormRequest: function () {
                let fd = {
                        fullName: this.formField.fullName,
                        email: this.formField.email,
                        phoneNumber: this.formField.phoneNumber,
                        company: this.formField.company,
                        message: this.formField.message,
                    };
                // Object.keys(this.formField).forEach(key => fd.append(key, this.formField[key]));
                axios({
                    url:'https://findworka-api.onrender.com/api/v1/forms/contact',
                    headers: {"Access-Control-Allow-Origin": "*", "api_key":"qfoudwCWJkPatcztt%bIxcuoMBEGK9tdv2%jz4Jt4y5CYpc2KAUkQXBfdJ0EeqRh5F!MyvyTO7VSdCoWfPd52RpEpB2arBJGVPtR03wXayBrKdWPFS3AdM0LswwGXQHmkMLwGvwJmcEjiOeZhQ2pxLcHaC3DU87B5Wvc8b5629f78a2d03a42cfde3a52c69tyeyhfj"},
                    'Content-Type': 'application/json' ,
                    method: 'post',
                    
                    data: fd
                    })
                    .then((response) => {
                        console.log(response)
                        if (response.data.error == true) {
                            // Should redirect to list if redirect was checked
                            this.$toasted.show(response.data.message[0])
                           // this.resetForm()
                        }else {
                            this.$toasted.show(response.data.message)
                            // this.$router.push({ name: 'home' })
							// this.$router.push({ name: 'payment' })
							// window.location.href = "http://siwei.me"
                        }
                            //Reset form
                    })
                    .catch(error => this.apiErrorCatcher(error))
                    .finally( () => this.resetForm())//clear form automatically after successful request
            },
            resetForm() {
                console.log('Reseting the form')
                var self = this; //you need this because *this* will refer to Object.keys below`

                //Iterate through each object field, key is name of the object field`
                Object.keys(this.formField).forEach(function(key,index) {
                self.formField[key] = '';
                });
            }
            
        }
};
</script>

<style scoped>
.__rowt {
  margin-top: 29%;
}

.__welf {
  line-height: 1.57;
  color: #69d9f5;
  font-family: Gilroy-Bold;
}

.__welf1 {
  font-size: 42px;
  line-height: 1.07;
  color: #ffffff;
  font-family: Gilroy-Bold;
}

.__welf2 {
  font-size: 16px;
  line-height: 1.38;
  color: #ffffff;
}

.__adjustlink {
    margin: 40px 0 100px;
    border-radius: 20px !important;
    background-color: #2357bb !important;
  color: #ffffff !important;
  padding: 10px 30px !important;
  transition: all 0.4s ease-in;
  font-family: Gilroy-Bold;
}

.__hirep {
  font-size: 24px;
  line-height: 1.11;
  color: #000000;
  font-family: Gilroy-Heavy;
}

.__hirep1 {
  font-size: 16px;
  line-height: 1.38;
  color: #000000;
}

.__form-wrap {
  background: #fff;
  border-radius: 1px;
  padding: 40px 30px;
  margin-top: -65px;
}


form {
  padding: 30px 0;
}

.__form-wrap .form-group {
  padding-top: 10px;
}

.__form-wrap .__form-control {
  border-radius: 1px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: #f6f6f6;
  box-shadow: none !important;
  height: 42px;
}

.__form-wrap .__form-control:focus {
  border: 1px solid #2357bb !important;
}

input[type="file"] {
  opacity: 0;
  width: 0.001px;
  height: 0.0001px;
  position: absolute;
  z-index: -1;
}

.filename
{
  font-size: 12px;
}

.cust-file {
  background-color: #f6f6f6;
  display: block;
  cursor: pointer;
  border-radius: 1px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  height: 42px;
  padding: 12px;
  color: rgba(85, 85, 85, 0.75);
  font-weight: normal;
}

.cust-file:hover,
input[type="file"]:focus + label.cust-file {
  border: 1px solid #2357bb;
}


</style>



// WEBPACK FOOTER //
// src/components/contact.vue